module.exports = __webpack_public_path__ + "img/fruit-figs-350x184.77c2e287.jpg";